module.exports = __webpack_public_path__ + "img/zhuyaochanping.a283c585.png";